import React, { FunctionComponent } from 'react';

import { OrbModalConfirm } from '../../../../../../components/orb-modal-confirm';
import { i18n } from '../../../../../../helpers/i18n';
import { ConfirmSubmodalProps } from '../types';

export const PermissionsExtendedReturnToDefaultModal: FunctionComponent<ConfirmSubmodalProps> = (props) => {
    return (
        <OrbModalConfirm
            title={i18n('settings-v2', 'permissions-extended-return-to-default-modal-title')}
            confirmLabel={i18n('settings-v2', 'permissions-extended-return-to-default-modal-confirm')}
            cancelLabel={i18n('settings-v2', 'permissions-extended-return-to-default-modal-cancel')}
            {...props}
        >
            {i18n('settings-v2', 'permissions-extended-return-to-default-modal-description')}
        </OrbModalConfirm>
    );
};
